import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import Home from './components/Home';
import {jwtDecode} from 'jwt-decode'; // Use the default import
import "./App.css";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loader, setLoader] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "" });
  // const navigate = useNavigate(); // Use navigate hook

  const checkTokenExpiration = () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const isTokenValid = decodedToken.exp * 1000 > Date.now();

        if (isTokenValid) {
          setIsLoggedIn(true);
        } else {
          // Token expired
          localStorage.removeItem("token");
          localStorage.removeItem('name');
          localStorage.removeItem('role');
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Token decoding error:", error);
        localStorage.removeItem("token");
        localStorage.removeItem('name');
        localStorage.removeItem('role');
        setIsLoggedIn(false);
      }
    } else {
      setIsLoggedIn(false);
    }
  };

  useEffect(() => {
    checkTokenExpiration();
  }, []);
  useEffect(() => {
    const checkAuth = async () => {
      await checkTokenExpiration();
    };
    checkAuth();
  }, []);


  const handleLogin = async (email, password) => {
    setLoader(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (response.ok && data.token) {
        localStorage.setItem("token", data?.token);
        localStorage.setItem("name", data?.user?.name);
        localStorage.setItem("role", data?.user?.role);
        setIsLoggedIn(true);
        setSnackbar({ open: true, message: "Login successful!", severity: "success" });
        return true;
      } else {
        setSnackbar({ open: true, message: "Login failed. Please check your credentials.", severity: "error" });
        return false;
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbar({ open: true, message: "An error occurred. Please try again.", severity: "error" });
      return false;
    } finally {
      setLoader(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('role');
    setIsLoggedIn(false);
    // navigate('/login');
    window.location.href = `${window.location.origin}/login`; 
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={!isLoggedIn ?  <LoginForm onLogin={handleLogin} loader={loader} snackbar={snackbar} setSnackbar={setSnackbar} /> : <Navigate to="/home"/> } />
        <Route path="/home" element={isLoggedIn ? <Home onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default App;
